import React from 'react';
import ButtonMinus from '../../buttons/buttonMinus';
import ButtonPlus from '../../buttons/buttonPlus';
import { inject, observer } from "mobx-react";

const CartProductComponent = ({
  image,
  title,
  data,
  price,
  quantity,
  handleClick,
  onClickMinus,
  onClickPlus,
  disableMinus,
  recipes,
  feathersStore })=> {


  return(
    <div className="cartProductCard">
      <div
        className="cartProductCardPic"
        style={{backgroundImage: `url(${image})`}}
        onClick={handleClick}
      >
      </div>
      <div className="details-container">
        <div className="cartProductCardDetails">
          <div className="cart-product-title">{title}</div>
          {recipes?.some(r => r.isProduct) && (
            <div className="cart-product-composition">
              {recipes.filter(r => r.isProduct).map(r =>
                `${r.name} ${r.unit === 'gr' ? `${r.quantity}gr` : r.unit === 'Piece' ? `×${r.quantity}` : `${r.quantity} ${r.unit}`}`
              ).join(', ')}
            </div>
          )}
          <div className="cartProductCardDetails-Data">{data}</div>
        </div>  
        <div className="cartProductCardDetails-P-Q-container">         
          <div className="cartProductCardDetails-Price">
            {feathersStore.formatMoney(parseFloat(price).toFixed(2))}
          </div>
          <div className="cartProductCardDetails-Quantity">
            <ButtonMinus onClick={onClickMinus} green={true} disabled={disableMinus}/>
              <span style={{margin:"10px"}}>{quantity}</span>
            <ButtonPlus onClick={onClickPlus} green={true}/>
          </div>          
        </div>       
      </div>
    </div>
  )
}

export default inject('feathersStore')(observer(CartProductComponent));